export default {
  id: {
    value: null,
    required: false,
    state: null
  },
  numeroProcesso: {
    value: null,
    required: true,
    state: null
  },
  cnj: {
    value: null,
    required: false,
    state: null
  },
  pessoaId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  assuntoId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  objetoAcaoId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  comarcaId: {
    value: null,
    required: true,
    state: null
  },
  prognosticoId: {
    value: null,
    required: true,
    state: null
  },
  faseId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  advogadoResponsavel: {
    value: null,
    required: true,
    state: null
  },
  advogadoContrario: {
    value: null,
    required: false,
    state: null
  },
  valorCausa: {
    value: null,
    required: true,
    state: null
  },
  valorCausa2: {
    value: null,
    required: false,
    state: null
  },
  dataDistribuicao: {
    value: null,
    required: true,
    state: null
  },
  ultimoAndamento: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/modal/ajuizamentomodal-form.js